<template>
  <mp-popover ref="popover" :placement="placement" position="relative" :use-portal="isUsePortal" close-on-select>
    <mp-popover-trigger :data-qa="dataQa">
      <slot name="popover-trigger">
        <mp-button-icon v-if="isDots" name="menu-kebab" :is-disabled="isDisabled" :is-loading="isLoading" />
        <mp-button
          v-else
          :variant="triggerVariant"
          :size="triggerSize"
          right-icon="caret-down"
          :is-disabled="isDisabled"
          :is-loading="isLoading"
          :variant-color="triggerVariantColor"
        >
          {{ triggerText }}
        </mp-button>
      </slot>
    </mp-popover-trigger>
    <mp-popover-content
      :max-width="dropdownWidth"
      :z-index="zIndex"
      bg="white"
      rounded="md"
      shadow="lg"
      border-width="1px"
      border-color="gray.400"
      class="text-break"
      overflow-y="auto"
      :max-height="dropdownHeight"
      white-space="normal"
    >
      <slot name="popover-content" />
    </mp-popover-content>
  </mp-popover>
</template>
<script>
export default {
  name: 'PixelPopover',
  props: {
    isDots: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
    triggerVariant: {
      type: String,
      default: 'solid',
    },
    triggerVariantColor: {
      type: String,
      default: 'blue',
    },
    triggerSize: {
      type: String,
      default: 'sm',
    },
    triggerText: {
      type: String,
      default: 'Actions',
    },
    dropdownWidth: {
      type: String,
      default: '200px',
    },
    dropdownHeight: {
      type: String,
      default: 'auto',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: [Number, String],
      default: 1,
    },
    dataQa: {
      type: String,
      default: '',
    },
    isUsePortal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$refs.popover.closePopover();
    },
  },
};
</script>
